import React from 'react';
import { ButtonV2, useDisclosure } from '@withjoy/joykit';
import { ReactComponent as PlayArrow } from '@assets/icons/play-arrow.svg';
import { ReactComponent as RoundPlayButton } from '@assets/icons/button-play-round.svg';
import { CurationVideoPlayerDialog } from './CurationVideoPlayerDialog';
import { useTranslation } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

interface CurationVideoPlayerProps
  extends Readonly<{
    curationId: string;
    videoUrl: string;
    eyebrow: Maybe<string>;
    title: Maybe<string>;
    variant: 'iconButton' | 'default';
    handleOnViewCurationClick: React.MouseEventHandler | null;
    onOpenVideoPlayer?: (method: 'playButton' | 'ctaButton') => void;
    onCloseVideoPlayer?: () => void;
  }> {}

const CurationVideoPlayer: React.FC<CurationVideoPlayerProps> = props => {
  const { t } = useTranslation('catalogRegistry');
  const { billboard } = t('curationHeroHeader');

  const { curationId, variant, videoUrl, eyebrow, title, handleOnViewCurationClick, onOpenVideoPlayer, onCloseVideoPlayer } = props;

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOnOpen = useEventCallback<React.MouseEventHandler<HTMLButtonElement>>(e => {
    onOpen();
    onOpenVideoPlayer?.(e.currentTarget.dataset['method'] as 'playButton' | 'ctaButton');
  });

  const handleOnCloseVideoDialog = useEventCallback(() => {
    onClose();
    onCloseVideoPlayer?.();
  });

  return (
    <>
      {variant === 'iconButton' ? (
        <ButtonV2
          variant="ghost"
          data-method="playButton"
          height="92px"
          width="92px"
          borderRadius="50%"
          startIcon={<RoundPlayButton height="92px" width="92px" />}
          onClick={handleOnOpen}
        />
      ) : (
        <ButtonV2 variant="outline" data-method="ctaButton" borderColor="white" startIcon={<PlayArrow height="14px" width="13px" />} onClick={handleOnOpen}>
          {billboard.watchButton()}
        </ButtonV2>
      )}
      <CurationVideoPlayerDialog
        curationId={curationId}
        videoUrl={videoUrl}
        eyebrow={eyebrow}
        title={title}
        onExploreCurationClick={handleOnViewCurationClick}
        isOpen={isOpen}
        onClose={handleOnCloseVideoDialog}
      />
    </>
  );
};

export { CurationVideoPlayer };
